import { firestore } from '../contexts/FirebaseContext';

export const getSaldoType = (categoriaId) => {
  let categoria;
  if (categoriaId === 'SERVICIO') {
    categoria = 'saldoServicio';
  }
  if (categoriaId === 'PAQUETERIA') {
    categoria = 'saldoPaqueteria';
  }
  if (categoriaId === 'RECARGA') {
    categoria = 'saldoRecarga';
  }

  return categoria;
};

export const getWalletUser = async (userId) => {
  const userWallet = await (await firestore.collection('wallets').doc(userId).get()).data();
  return userWallet;
};

export const getBalanceTypeUser = async (userId, categoriaId) => {
  const index = getSaldoType(categoriaId);
  const userWallet = await getWalletUser(userId);

  const balance = userWallet[index];
  return balance;
};
